import { useState } from "react";
import { Alert, Button, Form, Input, Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";

import { startPatternRule, validateMessages } from "../../utils/validation";
import classes from "./AddEntityModal.module.scss";
import { create } from "../../store/actions/vehicles-actions";

export default function AddVehicleModal({ open, onClose, onVehicleAdded }) {
  const [error, setError] = useState("");

  const dispatch = useDispatch();

  const onFinish = async (values) => {
    try {
      await dispatch(create(values));
      onVehicleAdded();
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong");
    }
  };

  const vehicleTypeOptions = useSelector(
    (state) => state.options.vehicleTypeOptions
  );

  return (
    <Modal
      className={classes.modal}
      open={open}
      onCancel={onClose}
      title="Add new vehicle"
      footer={null}
      destroyOnClose
      afterClose={() => setError("")}
      centered
      width={"50vw"}
      styles={{
        body: { minHeight: "280px", paddingRight: 24 },
        header: { background: "#d2dbdf", marginBottom: 32 },
        content: { background: "#d2dbdf" },
      }}
    >
      {error && <Alert style={{ marginTop: 0 }} message={error} type="error" />}
      <Form
        name="basic"
        onFinish={onFinish}
        autoComplete="off"
        layout="horizontal"
        validateMessages={validateMessages}
        size="large"
        labelCol={{ flex: "200px" }}
        labelAlign="left"
        labelWrap
      >
        <Form.Item
          name="licensePlate"
          label="Plate Number"
          rules={[{ required: "true", max: 20 }, startPatternRule]}
        >
          <Input placeholder="Enter licence plate" />
        </Form.Item>

        <Form.Item
          name="vehicleType"
          label="Vehicle Type"
          rules={[{ required: "true" }]}
        >
          <Select
            placeholder="Select vehicle type"
            options={vehicleTypeOptions}
          />
        </Form.Item>

        <Form.Item
          name="techNumber"
          label="Technical Passport Number"
          rules={[{ required: "true", max: 30 }, startPatternRule]}
        >
          <Input placeholder="Enter technical passport number" />
        </Form.Item>

        <div className={classes.customFooter}>
          <Form.Item>
            <Button
              className={classes.submitButton}
              type="primary"
              htmlType="submit"
            >
              Add vehicle
            </Button>
          </Form.Item>
          <Button onClick={onClose}>Cancel</Button>
        </div>
      </Form>
    </Modal>
  );
}
